/* eslint-disable no-console */
import { Auth } from 'aws-amplify';
import BaseComponent from 'foundation/base-component';
import Oauth from '../../sso/components/oauth';

import {
    OauthQueryConstants,
    removeParameterByName,
    getParameterByName,
    setOauthSignOutReturnUrl,
} from '../../../general/js/utils';
import { hasValue } from '../../../general/js/general-helpers';
import { getConfirmedEmailCustomState } from '../../sso/components/oauth/auth-provider-methods';

export default class SSOSignInComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    init = () => {
        this.addListener(this.refs.ssoSignIn, 'click', this.handleOnSignInClick);
        this.addListener(this.refs.ssoRegister, 'click', this.handleOnRegisterClick);
        this.handleForceSignIn();
        this.handleForceSignUp();
    }

    onDestroy() {
        this.refs.ssoSignIn.removeEventListener('click', this.handleOnSignInClick);
        this.refs.ssoRegister.removeEventListener('click', this.handleOnRegisterClick);
    }

    handleOnSignInClick = () => {
        try {
            Oauth.federatedSignIn();
        } catch (error) {
            console.error(error);
        }
    }

    handleOnRegisterClick = () => {
        try {
            Oauth.signUp();
        } catch (error) {
            console.error(error);
        }
    }

    handleForceSignIn = () => {
        const forceSignInQueryParams = getParameterByName(OauthQueryConstants.FORCE_SIGN_IN);
        if (!hasValue(forceSignInQueryParams)) {
            return;
        }

        removeParameterByName(OauthQueryConstants.FORCE_SIGN_IN);
        const customState = getConfirmedEmailCustomState();

        Oauth.getCurrentAuthenticatedUser()
            .then((user) => {
                if (!hasValue(user)) {
                    try {
                        Oauth.federatedSignIn(customState);
                    } catch (error) {
                        console.error(error);
                    }
                }
            })
            .catch(() => {
                try {
                    Oauth.federatedSignIn(customState);
                } catch (error) {
                    console.error(error);
                }
            });
    }

    handleForceSignUp = () => {
        const forceSignUpQueryParams = getParameterByName(OauthQueryConstants.FORCE_SIGN_UP);
        if (!hasValue(forceSignUpQueryParams)) {
            return;
        }

        Oauth.getCurrentAuthenticatedUser()
            .then((user) => {
                if (hasValue(user)) {
                    try {
                        setOauthSignOutReturnUrl();
                        Auth.signOut({ global });
                    } catch (error) {
                        console.error('Error signing out:', error);
                    }
                }
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => {
                removeParameterByName(OauthQueryConstants.FORCE_SIGN_UP);
                try {
                    Oauth.signUp();
                } catch (error) {
                    console.error(error);
                }
            });
    }
}
